module.exports = __webpack_public_path__ + "static/media/FacebookIcon.806bf5c2.svg";